import React from 'react';
import PropTypes from 'prop-types';
import enums from '~/utils/enums';

const Context = React.createContext();

const { featured, bestSelling, alphaAsc, alphaDesc, priceAsc, priceDesc } =
  enums.sortMethods;
const sortMethods = {
  Featured: featured,
  'Best selling': bestSelling,
  'Alphabetical, A to Z': alphaAsc,
  'Alphabetical, Z to A': alphaDesc,
  'Price, low to high': priceAsc,
  'Price, high to low': priceDesc,
};

class FilterContext extends React.Component {
  state = {
    activeFilters: {},
    activeFilterCount: 0,
    activeSortMethod: '',
  };

  componentDidMount = () => {
    const { getParam, setFilters, setSortMethod } = this.props;

    const activeFilters = JSON.parse(getParam('filters' || {})) || {};
    const activeFilterCount = this.getActiveFilterCount(activeFilters);
    const activeSortMethod = getParam('sort') || '';

    this.setState({
      activeFilters,
      activeFilterCount,
      activeSortMethod,
    });

    setFilters(activeFilters);
    setSortMethod(activeSortMethod);
  };

  getActiveFilterCount = activeFilters => {
    const activeFilterKeys = Object.keys(activeFilters);
    let activeFilterCount = 0;

    for (let i = 0; i < activeFilterKeys.length; i++) {
      const key = activeFilterKeys[i];
      const filter = activeFilters[key];

      if (filter === true) {
        activeFilterCount++;
      } else if (filter.length) {
        activeFilterCount += filter.length;
      }
    }

    return activeFilterCount;
  };

  setActiveFilters = (activeFilters = {}) => {
    const { deleteParam, setParam } = this.props;
    const activeFilterCount = this.getActiveFilterCount(activeFilters);

    this.setState({ activeFilters, activeFilterCount });

    if (Object.keys(activeFilters).length) {
      setParam('filters', JSON.stringify(activeFilters));
    } else {
      deleteParam('filters');
    }
  };

  setSortMethod = sortMethod => {
    const { deleteParam, setParam, setSortMethod } = this.props;

    this.setState({ activeSortMethod: sortMethod });
    setSortMethod(sortMethod);

    const firstSortMethod = sortMethods[Object.keys(sortMethods)[0]];

    if (sortMethod === firstSortMethod) {
      deleteParam('sort');
    } else {
      setParam('sort', sortMethod);
    }
  };

  render = () => {
    const { activeFilters, activeFilterCount, activeSortMethod } = this.state;

    return (
      <Context.Provider
        value={{
          activeFilters,
          activeFilterCount,
          setActiveFilters: this.setActiveFilters,
          sortMethods,
          activeSortMethod,
          setActiveSortMethod: this.setSortMethod,
        }}
      >
        {this.props.children}
      </Context.Provider>
    );
  };
}

// eslint-disable-next-line react/display-name
const withFilterContext = Rendered => props =>
  (
    <Context.Consumer>
      {value => <Rendered {...props} {...value} />}
    </Context.Consumer>
  );

FilterContext.propTypes = {
  getParam: PropTypes.func,
  deleteParam: PropTypes.func,
  setParam: PropTypes.func,
  setFilters: PropTypes.func,
  setSortMethod: PropTypes.func,
};

export { withFilterContext, FilterContext as default };
